import { Alert, Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../contexts/SampleSetContext';
import { ResultType } from '../../../../../enums';
import HydraDataQCTab from '../../../../../pages/experiments/resultsAnalysis/hydra/HydraDataQCTab';
import IdDataQCTab from '../../../../../pages/experiments/resultsAnalysis/id/IdDataQCTab';
import IdParquetDataQCTab from '../../../../../pages/experiments/resultsAnalysis/id/IdParquetDataQCTab';
import MwmineFeaturesDataQCTab from '../../../../../pages/experiments/resultsAnalysis/mwmineFeatures/MwmineFeaturesDataQCTab';
import PeptidesDataQCTab from '../../../../../pages/experiments/resultsAnalysis/peptides/PeptidesDataQCTab';
import QuantDataQCTab from '../../../../../pages/experiments/resultsAnalysis/quant/QuantDataQCTab';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/data-qc'
)({
  staticData: { ddViewName: 'experiments-data-qc-tab' },
  component: DataQCRouteComponent,
});

function DataQCRouteComponent() {
  const { selectedJob, selectedJobId, jobs } = useSampleSet();

  const showAlert = !selectedJobId && jobs.length > 0;

  let DataQCTab;
  switch (selectedJob?.result_type) {
    case ResultType.ID_PARQUET:
      DataQCTab = IdParquetDataQCTab;
      break;
    case ResultType.ID:
      DataQCTab = IdDataQCTab;
      break;
    case ResultType.HYDRA:
      DataQCTab = HydraDataQCTab;
      break;
    case ResultType.PEPTIDES:
      DataQCTab = PeptidesDataQCTab;
      break;
    case ResultType.MWMINE_FEATURES:
      DataQCTab = MwmineFeaturesDataQCTab;
      break;
    default:
      DataQCTab = QuantDataQCTab;
  }

  return (
    <>
      {showAlert && (
        <Box sx={{ mx: 2, mt: 1 }}>
          <Alert severity="info" sx={{ mb: 1 }}>
            Please select an inference run to view data QC results
          </Alert>
        </Box>
      )}
      {selectedJobId && <DataQCTab />}
    </>
  );
}
